module.exports = __webpack_public_path__ + "img/logo-WC-main-nav-drawer-white.250394e0.svg";